import { render } from "./ProcessAvailment.vue?vue&type=template&id=4fa01cf6"
import script from "./ProcessAvailment.vue?vue&type=script&lang=js"
export * from "./ProcessAvailment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__